/* mo:mo — Lieferzeit im Warenkorb aus der in Shopify hinterlegten Versandmethode.

   Shopify liefert die Lieferzeit ausschliesslich im *Namen* der Versandmethode
   ("Standard-Versand (3-4 Werktage)"); delivery_range ist bei diesen Tarifen leer.
   Deshalb geben wir den Namen unveraendert aus — aendert der Kunde ihn im Backend,
   aendert sich der Warenkorb automatisch mit. */
class MomoCartShipping extends HTMLElement {
  /* Der Rate-Endpoint verlangt zwingend eine PLZ, auch wenn die Versandzonen rein
     laenderbasiert sind. Repraesentative PLZ je Land — der zurueckgegebene Tarif ist
     derselbe wie im Checkout, solange keine PLZ-abhaengigen Zonen angelegt werden. */
  static ZIPS = { DE: '10115', AT: '1010', CH: '8001' };

  connectedCallback() {
    this.load();
  }

  async load() {
    const country = this.dataset.country;
    if (!country) return;

    const zip = MomoCartShipping.ZIPS[country] || '10115';
    const url =
      '/cart/shipping_rates.json?shipping_address%5Bcountry%5D=' +
      encodeURIComponent(country) +
      '&shipping_address%5Bzip%5D=' +
      encodeURIComponent(zip);

    try {
      const res = await fetch(url);
      if (!res.ok) return;
      const data = await res.json();
      const rates = data.shipping_rates || [];
      if (rates.length === 0) return;

      /* Shopify waehlt im Checkout den guenstigsten Tarif vor — denselben zeigen wir an,
         damit Warenkorb und Checkout nicht auseinanderlaufen. */
      const rate = rates.slice().sort((a, b) => parseFloat(a.price) - parseFloat(b.price))[0];
      this.textContent = rate.name;
    } catch (e) {
      /* Bewusst still: lieber nichts anzeigen als eine falsche Lieferzeit. */
    }
  }
}

if (!customElements.get('momo-cart-shipping')) {
  customElements.define('momo-cart-shipping', MomoCartShipping);
}
